import request from '../utils/request';

export function postUserLog (data){
    return request({
        url: "/wxmanager/log/userLog",
        method:'post',
        data,
    });
}
export function postOncePush (data){
    return request({
        url: "/wxmanager/log/userOncePush",
        method:'post',
        data,
    });
}